import { gql, TypedDocumentNode } from "@apollo/client";

import { ApiKey, MutationPersonalApiKeyCreateArgs } from "types/generated";

type PersonalApiKeyCreate = {
  personalApiKeyCreate: Pick<ApiKey, "id" | "name" | "secret">;
};

export const CREATE_PERSONAL_API_KEY: TypedDocumentNode<
  PersonalApiKeyCreate,
  MutationPersonalApiKeyCreateArgs
> = gql`
  mutation PersonalApiKeyCreate($input: PersonalApiKeyInput!) {
    personalApiKeyCreate(input: $input) {
      id
      name
      secret
    }
  }
`;
